import { TQuoteLineItem } from "../common/types/quote";

export const getLineItemsTotalPrice = (list: TQuoteLineItem[]): number => list.reduce<number>((acc, { price }) => {
    const numberPrice = Number(price);
    acc+= isNaN(numberPrice) ? 0 : numberPrice;
    return acc;
}, 0);
